import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSortList } from "consts/sort";
import MainSortButtons from "./MainSortButtons";
import MainSortOrder from "./MainSortOrder";
import MainSortInputSearch from "./MainSortInputSearch";
import MainSortTutorLink from "./MainSortTutorLink";

const MainSort = ({ currentSort, setCurrentSort, setOffsetCount }) => {
  const { pathname } = useLocation();
  const [placeholder, setPlaceholder] = useState("");
  const [sortList, setSortList] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [isPopup, setIsPopup] = useState(false);
  const data = getSortList(pathname);

  useEffect(() => {
    setPlaceholder(data.placeholder);
    setSortList(data.list);
    setCurrentSort(data.list[0]);
    setButtons(data.buttons);
    setIsPopup(false);
  }, [pathname]);

  useEffect(() => {
    setOffsetCount(0);
  }, [currentSort]);

  if (sortList || sortList.length) {
    return (
      <div className="gradient-block__search">
        <MainSortInputSearch placeholder={placeholder} />
        {/* <MainSortTutorLink /> */}
        <MainSortOrder
          isPopup={isPopup}
          setIsPopup={setIsPopup}
          current={currentSort.label}
          setCurrentSort={setCurrentSort}
          list={sortList}
        />
        {buttons.length && <MainSortButtons data={buttons} />}
      </div>
    );
  }
};

export default MainSort;
